exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".perf-tool .settings{padding:1em}.perf-tool .settings h4{font-weight:500;font-size:1.2em;margin:.5em 0}.perf-tool .settings-list li{margin:1em}.perf-tool .settings-list li label{margin-right:.5em}.perf-tool .settings-list li input{outline:none;border:1px solid #a3a3a3;border-radius:2px;padding:.3em}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/styles/settings.css
 ** module id = 218
 ** module chunks = 0
 **/